import { HowlOptions } from 'howler';

const map = new Map<string, Howl>();

export const stopAllSounds = () => {
  Howler.stop();
};

let lastVolume = 1;
export const unmuteSounds = () => {
  muteSounds(false);
};
export const muteSounds = (value = true) => {
  try {
    if (value) {
      lastVolume = Howler.volume();
      Howler.volume(0);
    } else {
      Howler.volume(lastVolume);
    }
  } catch (err) {
    console.warn('Error muting sounds:', err);
  }
};

// Fonction utilitaire pour s'assurer que les valeurs audio sont valides
const ensureFiniteValue = (value: number): number => {
  if (!Number.isFinite(value)) {
    console.warn('Non-finite audio value detected, using 0 instead:', value);
    return 0;
  }
  return value;
};

export const playSound = (
  soundPath: string,
  options: Omit<HowlOptions, 'src'> = {}
): Howl => {
  // default options
  const defaultOptions: Partial<HowlOptions> = {
    onloaderror: (_id, error) => {
      console.log('error loading sound:', error);
    },
  };

  // Vérifier et corriger le volume s'il est défini
  if (options.volume !== undefined) {
    options.volume = ensureFiniteValue(options.volume);
  }

  try {
    const sound = new Howl({ src: [soundPath], ...defaultOptions, ...options });

    // auto garbage if played once
    if (!options.loop) {
      sound.once('end', () => {
        try {
          sound.unload();
          map.delete(soundPath);
        } catch (err) {
          console.warn('Error unloading sound:', err);
        }
      });
    }

    sound.play();
    map.set(soundPath, sound);
    return sound;
  } catch (err) {
    console.error('Error playing sound:', soundPath, err);
    // Retourner un objet Howl vide mais valide pour éviter les erreurs
    return new Howl({ src: [''] });
  }
};

export const stopSound = (
  soundPath: string,
  fadeOut = 0,
  andUnload?: boolean
) => {
  if (map.has(soundPath)) {
    // lets stop the sound by fading out
    const sound = map.get(soundPath);
    if (sound) {
      try {
        // Vérifier que le volume actuel est valide
        const currentVolume = ensureFiniteValue(sound.volume());
        sound.fade(currentVolume, 0, fadeOut);

        setTimeout(() => {
          try {
            sound.stop();
            if (andUnload) {
              unloadSound(soundPath);
            }
          } catch (err) {
            console.warn('Error stopping sound:', err);
          }
        }, fadeOut);
      } catch (err) {
        console.error('Error fading sound:', err);
        // En cas d'erreur, essayer d'arrêter le son directement
        try {
          sound.stop();
          if (andUnload) {
            unloadSound(soundPath);
          }
        } catch (innerErr) {
          console.warn('Error in fallback sound stopping:', innerErr);
        }
      }
    }
  }
};

const unloadSound = (soundPath: string) => {
  if (map.has(soundPath)) {
    try {
      map.get(soundPath)?.unload();
      map.delete(soundPath);
    } catch (err) {
      console.warn('Error unloading sound:', err);
      // Supprimer de la map même en cas d'erreur
      map.delete(soundPath);
    }
  }
};
